<template>
  <div class="globar-footer">
    <div class="footer-content">
      <div class="phone flex flex-sb public-flex-row">
        <h2>
          全国服务热线
          <img src="@/assets/img/phone.png" alt="" />
          <span>010-63724489</span>
        </h2>
        <img src="@/assets/img/logo_white2.png" class="footer-logo"> 
        <img src="@/assets/img/gzh_code.jpeg" class="code-image2">
      </div>
      <div class="hr"></div>
      <div class="foot-msg flex flex-sb">
        <ul>
          <li>
            京ICP备2022005757号
            <br>
            违法和不良信息举报邮箱：su.wang@shantongltd.com
          </li>
          <li>
            © copyright 2022-2023 山童科技. All rights reserved. 版权所有
            <br>本站内容未经书面许可,禁止一切形式的转载。
          </li>
        </ul>
        <!-- <div><img src="~@/assets/images/icon/foot-logo.png" /></div> -->
         <img src="@/assets/img/gzh_code.jpeg" class="code-image">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>

<style scoped>
.public-flex-row {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
}
.globar-footer {
  width: 100%;
  height: 280px;
  background: #000000;
  overflow: hidden;
}
.footer-content {
  width: 1150px;
  margin: 0 auto;
  padding-top: 36px;
  color: #fff;
}
.phone > h2 {
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-size: 18px;
  line-height: 28px;
  display: flex;
  flex-direction: row;
  
}
.phone > h2 > img {
  width: 28px;
  height: 28px;
  margin-left: 18px;
  margin-right: 7px;
  vertical-align: middle;
}
.phone > h2 > span {
  vertical-align: middle;
}
.phone > ul li {
  margin-left: 16px;
}
.phone > ul li > li:first-child {
  margin-left: 0;
}
.phone > ul li >img {
  width: 18px;
  height: 18px;
}
.hr {
  border: 1px solid #616161;
  margin-top: 27px;
  margin-bottom: 26px;
}
.foot-msg {
  font-size: 13px;
  color: #cecece;
  line-height: 20px;
}
.foot-msg > ul li {
  font-family: AlibabaPuHuiTi_2_45_Light;
}
.foot-msg > ul li > li:last-child {
  margin-top: 14px;
}
.foot-msg > ul li > span {
  margin-left: 10px;
}
.foot-msg > div {
  width: 115px;
  height: 25px;
}
.foot-msg > div > img {
  width: 100%;
  height: 100%;
}
.footer-logo{
  width: 166px;
  height: 34px;
}
.code-image {
  width: 70px;
  height: 70px;
  position: relative;
  top: -91px;
  right: -1070px;
}
/* 隐藏二维码 */
@media screen and (min-width: 768px) {
.code-image2 {
   display: none;
}
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
/* 二维码样式 */
/* 隐藏二维码 */
.code-image {
   display: none;
}
.code-image2 {
  width: 70px;
  height: 70px;
}
/* 底部hr线条样式 */
.hr {
  border: 1px solid #616161;
  margin-top: 27px;
  margin-bottom: 26px;
  width: auto;
}
/* 底部样式 */
.footer-content {
  width: auto;
  margin: 0 auto;
  padding-top: 36px;
  color: #fff;
}
.foot-msg {
  font-size: 13px;
  color: #cecece;
  line-height: 20px;
  padding: 0 0 0 10px;
}
.phone > h2 {
  padding: 0 0 0 10px;
}
.footer-logo{
 display: none;
}

}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue